import React from "react";
import { classNames } from "primereact/utils";
import PropTypes from "prop-types";

import EzControlledDropDown from "../";

const EzControlledDropDowntWithFloatingLabel = (props) => {
  const {
    control,
    name,
    rules,
    options,
    optionLabel,
    optionValue,
    onChange,
    labelClassName,
    label,
    id,
    filter,
    errorMsg,
    isError,
    disabled,
    panelClassName,
    appendTo,
  } = props;

  const getLabelClassName = () => {
    return classNames({
      "p-error": isError,
      labelClassName,
    });
  };

  return (
    <div className="field">
      <span className="p-float-label">
        <EzControlledDropDown
          disabled={disabled}
          filter={filter}
          name={name}
          id={id}
          optionLabel={optionLabel}
          optionValue={optionValue}
          onChange={onChange}
          control={control}
          rules={rules}
          options={options}
          panelClassName={panelClassName}
          appendTo={appendTo}
        />
        <label htmlFor={name} className={getLabelClassName()}>
          {rules?.required ? (
            <>
              {label}
              <span style={{ color: "red" }}>*</span>
            </>
          ) : (
            label
          )}
        </label>
      </span>
      {errorMsg}
    </div>
  );
};

EzControlledDropDowntWithFloatingLabel.defaultProps = {
  labelClassName: "",
  filter: false,
  optionLabel: "label",
  optionValue: "value",
};

EzControlledDropDowntWithFloatingLabel.propTypes = {
  labelClassName: PropTypes.string,
  filter: PropTypes.bool,
  optionLabel: PropTypes.string,
  optionValue: PropTypes.string,
};

export default EzControlledDropDowntWithFloatingLabel;
